import {FC} from 'react';
import {RegularModal} from 'modules/modals/components/RegularModal';
import Picture from 'components/Picture';
import {EVENT_HALL_INFO_MODAL_IMAGE} from './constants';
import style from './style.module.scss';
import {Typography} from 'components/Typography';
import {splitTextWithBr} from 'core/helpers/string';

export const EventHallInfoModal: FC = () => {
    return (
        <RegularModal
            hasClose={true}
            className={style.root}
            classNameTitle={style.title}
            classNameContent={style.content}
            title={splitTextWithBr('Что такое<br/>дегустационный зал?')}
            isMobileBottomAlign={true}
        >
            <Picture src={EVENT_HALL_INFO_MODAL_IMAGE} className={style.eventHallInfoImage} />
            <div className={style.infoTextWrapper}>
                <Typography variant={'body-16-r'}>
                    Это отдельная комната в винотеке с большим экраном для интерактива. Идеально для полного погружения
                    в мир вина и индивидуальных дегустаций для компании.
                </Typography>
            </div>
        </RegularModal>
    );
};
